import React, {useEffect, useState} from "react";
import {BidCreationType, BidSummaryModel} from "../bidding_model";
import {Link, useNavigate, useParams} from "react-router-dom";
import {ColumnDef} from "@tanstack/react-table";
import {DataTable} from "../../ui/dataTable";
import {
    Card,
    CardContent,
    CardHeader,
    CardTitle,
} from "../../ui/card";
import {Badge} from '../../ui/badge'
import {dateFormatter, formatDate, moneyFormatter} from "../../../lib/formatters";
import {Button} from "../../ui/button";
import {LinkedCell, SortableHeader} from "../../ui/tableUtils";
import {useAuthInfo} from "@propelauth/react";
import {fetchWithToken} from "../../../api/apiBase";
import {CopyButton2, CopyText} from "../../exportData/CopyButton";
import {CopyQlinkButton} from "../../qlink/QlinkCopyButton";


const _baseSummaryColumns: ColumnDef<BidSummaryModel>[] = [

    {
        header: "Link",
        accessorKey: "company.name",
        cell: ({row}) =>
            <div className="flex items-center justify-between">
            {row.original.link_id &&
                <CopyQlinkButton link_id={row.original.link_id}/>
            }
        </div>
    },

    {
        header: "Company",
        accessorKey: "company.name",
        cell: ({row}) =>
            <div className="flex items-center justify-between">
            <span>
                {row.original.company
                    ? row.original.company.name
                    : row.original.user
                }
            </span>
            {/*{row.original.link_id &&*/}
            {/*    <CopyQlinkButton link_id={row.original.link_id}/>*/}
            {/*}*/}
        </div>
    },

    {
        header: ({column}) => (<SortableHeader column={column} name={"Amount"}/>),
        accessorKey: "latest_bid.bid_amount",
        cell: ({row}) => {
            if (!row.original.latest_bid) {
                return <div className="text-xs">None submitted</div>
            }
            return (
                <Link
                    to={`/project/${row.original.latest_bid.project_id}/bid/${row.original.latest_bid._id}`}
                >
                    <div className="text-lg font-medium hover:underline">
                        {moneyFormatter.format(row.original.latest_bid?.bid_amount)}
                    </div>
                </Link>
            );
        },
    },
    {
        header: ({column}) => (<SortableHeader column={column} name={"Submitted"}/>),
        id: "dss",
        accessorKey: "latest_bid.bid_amount",
        cell: ({row}) => {
            if (!row.original.latest_bid) {
                return <div></div>
            }
            return (
                <div className="font-medium hover:underline">

                    {row.original.latest_bid?.submitted_at
                        ? formatDate(row.original.latest_bid?.submitted_at)
                        : <Badge variant="warning">Pending</Badge>
                    }
                </div>
            );
        },

    },
]

export const _columns: ColumnDef<BidSummaryModel>[] = [
    {
        header: "Company",
        accessorKey: "company.name",
    },
    {
        header: ({column}) => (<SortableHeader column={column} name={"Amount"}/>),
        accessorKey: "latest_bid.bid_amount",
        cell: ({row}) => {
            if (!row.original.latest_bid) {
                return <div className="text-xs">None submitted</div>
            }
            return (
                <Link
                    to={`/project/${row.original.project_id}/bid/${row.original.latest_bid._id}`}
                >
                    <div className="text-lg font-medium hover:underline">
                        {moneyFormatter.format(row.original.latest_bid?.bid_amount)}
                    </div>
                </Link>
            );
        },
    },
    {
        header: ({column}) => (<SortableHeader column={column} name={"Submitted"}/>),
        id: "dss",
        accessorKey: "latest_bid.bid_amount",
        cell: ({row}) => {
            if (!row.original.latest_bid) {
                return <div></div>
            }
            return (
                <div className="font-medium hover:underline">
                    {formatDate(row.original.latest_bid?.submitted_at)}
                </div>
            );
        },
    },
    {
        header: "VE Suggested",
        cell: ({row}) => {
            return (
                <div className="">
                    {moneyFormatter.format(
                        row.original.ve_summary.best_savings_potential
                    )}
                </div>
            );
        },
    },
    {
        header: "Lowest Potential Price",
        cell: ({row}) => {
            if (!row.original.latest_bid) {
                return <div></div>
            }
            const amount = row.original.ve_summary.best_savings_potential
            const formatted = moneyFormatter.format(
                row.original.latest_bid?.bid_amount - amount);
            return (
                <div className="">
                    {formatted}
                </div>
            );
        },
    }
];


/**
 * bid summary for scopes page
 * */
export const ScopedDeveloperBidSummarySD = () => {
    const navigate = useNavigate();
    const {accessToken} = useAuthInfo();

    const {project_id, scope_id} = useParams<{ project_id: string, scope_id: string }>();
    const [feedback, setFeedback] = useState<BidSummaryModel[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            if (accessToken) {
                let url = scope_id
                    ? `/projects/${project_id}/feedback/?scope_id=${scope_id}`
                    : `/projects/${project_id}/feedback/`

                const response = await fetchWithToken(url, accessToken);
                console.log(response);
                setFeedback(response);
            }
        }
        fetchData()
    }, [project_id, scope_id]);

    if (!project_id) {
        return <></>;
    }
    return <DataTable data={feedback} columns={_baseSummaryColumns}/>;

};


/**
 * bid summary for home page
 * */
export const DeveloperBidSummarySD = () => {
    const {accessToken} = useAuthInfo();

    const {project_id, scope_id} = useParams<{ project_id: string, scope_id: string }>();
    const [feedback, setFeedback] = useState<BidSummaryModel[]>([]);
    const [isEmpty, setIsEmpty] = useState<boolean>(true);

    useEffect(() => {
        const fetchData = async () => {
            if (accessToken) {
                let url = scope_id
                    ? `/projects/${project_id}/feedback/?scope_id=${scope_id}`
                    : `/projects/${project_id}/feedback/`

                const response = await fetchWithToken(url, accessToken);
                setFeedback(response);
                if (response.length > 0) {
                    setIsEmpty(false);
                }
                // console.log(response);
            }
        }
        fetchData()
    }, [project_id, scope_id]);

    if (!project_id || isEmpty) {
        return <></>;
    }
    return <DataTable data={feedback} columns={_columns}/>;

};




